"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var preact_1 = require("preact");
var utils_1 = require("../libs/utils");
var Label_1 = require("./Label");
var ChangelogPreview = function (props) {
    var changelog = props.changelog;
    var renderLabel = function (label, index) { return (preact_1.h(Label_1.default, tslib_1.__assign({ key: index }, label))); };
    return (preact_1.h("div", { className: "w-full transition cursor-pointer hover:bg-gray-100" },
        preact_1.h("div", { className: "border-l p-3 " +
                (utils_1.checkIfChangelogViewed(changelog.id.toString())
                    ? "border-transparent"
                    : "border-primary") },
            preact_1.h("h2", { className: "pb-1 text-xs font-medium break-words" }, changelog.title),
            preact_1.h("p", { className: "text-xs text-gray-900 break-words" },
                preact_1.h("span", { className: "text-xs text-gray-600" },
                    changelog.published_at,
                    changelog.description && changelog.description.length && (preact_1.h("span", null,
                        " \u2022 ",
                        changelog.description))),
                preact_1.h("div", { className: "mt-2" }, changelog.labels.map(renderLabel))))));
};
exports.default = ChangelogPreview;
